// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"36881f99","453":"b53256ab","818":"091ee42f","995":"f22fdf36"}[chunkId] + ".chunk.css";
};